export type PromiseWithResolvers<TData> = ReturnType<typeof promiseWithResolvers<TData>>

export const promiseWithResolvers = <TData>() => {
  let resolve: (value: TData | PromiseLike<TData>) => void
  let reject: (reason?: any) => void

  const promise = new Promise<TData>((res, rej) => {
    resolve = res
    reject = rej
  })

  // @ts-ignore
  return { promise, resolve, reject }
}

promiseWithResolvers.resolve = <TData>(data: TData) => {
  const promise = promiseWithResolvers<TData>()
  promise.resolve(data)
  return promise
}

promiseWithResolvers.reject = <TData>(reason?: any) => {
  const promise = promiseWithResolvers<TData>()
  promise.reject(reason)
  return promise
}
